import { composeDataModules } from '@perpay-web/data-module/composeDataModules';
import { fetchDirectDepositDashboardSummaryDataModule } from '@perpay-web/fintech/dataModules/fetchDirectDepositDashboardSummary';
import { fetchFeatureEnrollmentsDataModule } from '@perpay-web/fintech/dataModules/fetchFeatureEnrollments';
import { fetchJobsDataModule } from '@perpay-web/fintech/dataModules/fetchJobs';
import { fetchMarketplaceDashboardSummaryDataModule } from '@perpay-web/fintech/dataModules/fetchMarketplaceDashboardSummary';
import { fetchPerpayPlusDashboardSummaryDataModule } from '@perpay-web/fintech/dataModules/fetchPerpayPlusDashboardSummary';
import { fetchUserInfoDataModule } from '@perpay-web/fintech/dataModules/fetchUserInfo';

const PerpayPlusSoloApplicationDataModule = composeDataModules([
    fetchMarketplaceDashboardSummaryDataModule,
    fetchFeatureEnrollmentsDataModule,
    fetchDirectDepositDashboardSummaryDataModule,
    fetchPerpayPlusDashboardSummaryDataModule,
    fetchUserInfoDataModule,
    fetchJobsDataModule,
]);

const getRoot = (state) => state.dataModules.perpayPlusSoloApplication;

export const perpayPlusSoloApplicationDataModule =
    PerpayPlusSoloApplicationDataModule({
        getRoot,
        key: 'PERPAY_PLUS_SOLO_APPLICATION',
    });
